import React from 'react';

function InvalidOperation() {
  return (
    <div style={{padding: '50px'}}>
    </div>
  );
}

export default InvalidOperation;
